import { render } from "./TemporaryBooking.vue?vue&type=template&id=01842070&scoped=true"
import script from "./TemporaryBooking.vue?vue&type=script&lang=js"
export * from "./TemporaryBooking.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=01842070&scoped=true&lang=css&external"
import "./TemporaryBooking.vue?vue&type=style&index=1&id=01842070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01842070"]])

export default __exports__